import { useEffect, useRef, useState } from 'react';

import { authApi } from 'api';
import { AuthData, authUtils, returnUrlUtils } from 'utils';

// The endpoint authenticates by the refresh token cookie, but its passport strategy
// still rejects requests without an Authorization header
const AUTHORIZATION_PLACEHOLDER = 'refresh-token-cookie';

// The access token lives in local storage while the refresh token is an http-only
// cookie, so a lost access token leaves a still valid session unusable without this
export const useSessionRestore = () => {
  const [isRestoring, setIsRestoring] = useState(
    () => !authUtils.isLoggedIn() && !!returnUrlUtils.getCurrentUrl(),
  );
  const isStartedRef = useRef(false);

  useEffect(() => {
    if (!isRestoring || isStartedRef.current) {
      return;
    }
    isStartedRef.current = true;
    authApi
      .refreshAccessToken(AUTHORIZATION_PLACEHOLDER)
      .then((authData: AuthData) => {
        authUtils.setAuthData(authData);
      })
      .catch(() => {
        // no valid refresh token: the user has to log in again
      })
      .finally(() => {
        setIsRestoring(false);
      });
  }, [isRestoring]);

  return isRestoring;
};
